import { useLocation } from "react-router-dom";
import { GoalState, GoalVisibility } from "types/graphql-schema";
import { TFLocationState } from "types/topicflow";

import DraftLabel from "@components/draft-label/draft-label";
import GoalVisibilityIcon from "@components/goal-visibility-icon/goal-visibility-icon";
import AppLink from "@components/link/link";
import { getUrlUsingTypename } from "@helpers/helpers";

import { IndividualGoalAssessmentQuestion } from "./types";

const IndividualGoalQuestionLink = ({
  data,
}: {
  data: IndividualGoalAssessmentQuestion;
}) => {
  const location = useLocation<TFLocationState>();
  if (!data.goal) {
    return null;
  }
  return (
    <AppLink
      to={getUrlUsingTypename(data.goal, location)}
      className="tf-header-base-dark hover:underline"
    >
      {data.goal.title}{" "}
      {data.goal.goalVisibility === GoalVisibility.Private && (
        <GoalVisibilityIcon
          className="inline"
          goalVisibility={data.goal.goalVisibility}
          size="4"
        />
      )}{" "}
      {data.goal.state === GoalState.Draft && <DraftLabel />}
    </AppLink>
  );
};

export default IndividualGoalQuestionLink;
